import React from 'react';

type BadgeVariant = 'approved' | 'pending' | 'rejected' | 'admin' | 'default';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  approved: 'badge-approved',
  pending: 'badge-pending',
  rejected: 'badge-rejected',
  admin: 'badge-admin',
  default: 'bg-muted text-muted-foreground border border-border',
};

export default function Badge({ variant = 'default', children, className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold tracking-wide ${variantClasses[variant]} ${className}`}
    >
      {children}
    </span>
  );
}